<template>
    <button
        v-if="variant === 'mobile'"
        @click="showConfirmModal"
        :disabled="isDisabled"
        :class="[
            'transition-opacity duration-300 ease-in-out',
            'h-auto font-semibold tracking-normal flex items-center justify-center text-[16px]',
            'hover:text-red',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
            classes
        ]"
    >
        <div class="mr-2 flex items-center justify-center" v-if="$slots.image">
            <slot name="image" />
        </div>
        <slot name="cta">
            {{ fallbackCtaCopy }}
        </slot>
    </button>
    <button
        v-else
        @click="showConfirmModal"
        :disabled="isDisabled"
        :class="[
            'underline normal-case text-base tracking-snug flex items-center',
            'hover:text-red',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
            classes
        ]"
    >
        <div class="mr-1 flex items-center justify-center" v-if="$slots.image">
            <slot name="image" />
        </div>
        <span>
            <slot name="cta">
                {{ fallbackCtaCopy }}
            </slot>
        </span>
    </button>

    <teleport :to="teleportTarget" v-if="showModal">
        <base-modal-confirm
            @modalClose="showModal = false"
            @confirmAndExit="confirmAndClose"
            :show-modal="showModal"
            :modal-heading="modalHeading"
            :modal-copy="modalCopy"
            :cta-copy="modalConfirmCopy"
        />
    </teleport>
</template>

<script>
    import BaseModalConfirm from '../BaseModalConfirm.vue';

    export default {
        emits: ['confirm', 'reset'],

        components: {
            BaseModalConfirm,
        },

        props: {
            classes: {
                type: [String, Array],
                default: '',
            },
            variant: {
                type: String,
                default: '',
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            modalHeading: {
                type: String,
                default: '',
            },
            modalCopy: {
                type: String,
                default: '',
            },
            teleportTarget: {
                type: String,
                default: '#cz3',
            },
        },

        data() {
            return {
                showModal: false,
            };
        },

        computed: {
            fallbackCtaCopy() {
                return this.$t('RESET');
            },

            modalConfirmCopy() {
                const ctaNodes = this.$slots.cta?.() ?? this.$slots.default?.() ?? [];
                const slotText = this.flattenVNodeText(ctaNodes).trim();

                return slotText || this.fallbackCtaCopy;
            },
        },

        methods: {
            showConfirmModal() {
                this.showModal = true;
            },

            flattenVNodeText(nodes = []) {
                return nodes.map((node) => {
                    if (typeof node === 'string') {
                        return node;
                    }

                    if (typeof node?.children === 'string') {
                        return node.children;
                    }

                    if (Array.isArray(node?.children)) {
                        return this.flattenVNodeText(node.children);
                    }

                    return '';
                }).join('');
            },

            confirmAndClose() {
                this.$emit('confirm');
                this.$emit('reset');
                this.showModal = false;
            },
        },
    };
</script>
